import React, { memo } from 'react';

import { compose } from 'lodash/fp';
import PropTypes from 'prop-types';

import { INPUT_TYPES } from 'constants/technical';
import { withHandleNumberType } from 'utils/enhancers';

import { TextField } from './style';

export const TextFieldCustomComponent = ({
  variant,
  size,
  fullWidth,
  select,
  label,
  value,
  onChange,
  className,
  type,
  disabled,
  validators,
  ...props
}) => (
  <TextField
    variant={variant}
    size={size}
    fullWidth={fullWidth}
    select={select}
    label={label}
    value={value}
    onChange={onChange}
    className={className}
    type={type}
    disabled={disabled}
    validators={validators}
    {...props}
  />
);

TextFieldCustomComponent.propTypes = {
  variant: PropTypes.string,
  size: PropTypes.string,
  fullWidth: PropTypes.bool,
  select: PropTypes.bool,
  label: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onChange: PropTypes.func,
  className: PropTypes.string,
  type: PropTypes.string,
  disabled: PropTypes.bool,
  validators: PropTypes.arrayOf(PropTypes.string),
};

TextFieldCustomComponent.defaultProps = {
  variant: 'outlined',
  size: 'small',
  fullWidth: false,
  select: false,
  label: '',
  value: '',
  onChange: () => {},
  className: '',
  type: INPUT_TYPES.TEXT,
  disabled: false,
  validators: [],
};

export const TextFieldComponent = compose(withHandleNumberType, memo)(TextFieldCustomComponent);
